import moment from "moment";
/**
 * HELPER FUNCTIONS
 * @param skippedDates
 * @param day
 * @returns
 */
const checkIfSkipped = (skippedDates, day) => {
    if (!skippedDates)
        return false;
    return skippedDates.has(moment.utc(day.DateFormatted).format("YYYY-MM-DD"));
};
/**
 *
 * @param days
 * @param skippedDays
 * @returns
 */
export const getDefaultSelectedDay = (days, skippedDays) => {
    var _a;
    if (!days.length) {
        return null;
    }
    // Convert skipped days into a Set for quick lookup, ensuring UTC consistency.
    const skippedDates = skippedDays
        ? new Set(skippedDays === null || skippedDays === void 0 ? void 0 : skippedDays.map((skipDay) => moment.utc(skipDay.customerDate).format("YYYY-MM-DD")))
        : undefined;
    // Get valid days that have meals/products available, are not past the cutoff, are not skipped.
    const validDates = days.filter((day) => {
        const isSkipped = checkIfSkipped(skippedDates, day);
        return day.HasMealsOrProducts && !day.IsDayPastCutOff && !isSkipped;
    });
    let earliestDate;
    if (validDates.length) {
        // Find the earliest available valid date.
        earliestDate = moment.min(validDates.map((day) => moment.utc(day.DateFormatted)));
    }
    else {
        // If no valid dates are available, filter out past cutoff days.
        const availableDays = days.filter((day) => {
            const isSkipped = checkIfSkipped(skippedDates, day);
            return !day.IsDayPastCutOff && !isSkipped;
        });
        // Select the earliest available day, prioritizing non-cutoff days.
        earliestDate = moment.min((availableDays.length ? availableDays : days).map((day) => moment.utc(day.DateFormatted)));
    }
    return (_a = days.find((day) => moment.utc(day.DateFormatted).isSame(earliestDate, "day"))) !== null && _a !== void 0 ? _a : null;
};
